export default __webpack_public_path__ + "static/media/formas-digitales-nosotros-vision.f9280c5d.png";